import { yup } from "@swa-ui/object";

export const WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAME = "wheelChairAssistance";

export const WHEELCHAIR_ASSISTANCE_OPTIONS = {
  AIRCRAFT_SEAT_ASSISTANCE: "aircraftSeatAssistance",
  GATE_ASSISTANCE: "gateAssistance",
  NO_ASSISTANCE: "noAssistance",
};

export const getWheelchairAssistanceFormFieldSchema = (fieldName) => {
  const wheelchairAssistanceFieldName = fieldName ?? WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAME;

  return {
    [wheelchairAssistanceFieldName]: yup.string(),
  };
};
